export default __webpack_public_path__ + "static/media/contacts.ddd7683d.svg";